import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { Modal } from 'ant-design-vue'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import router, { resetRouter } from '../router'

// 创建 axios 实例
const request2 = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL_USER,
  timeout: 60000, // 请求超时时间
  withCredentials: true, //允许跨域
})

let errorFlag = false
// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: data.msg,
        description: '',
      })
      return false;
      //router.push('/user/login');
    }
    if (error.response.status === 404) {
      notification.error({
        message: '请求资源不存在',
        description: '',
      })
      return false
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: '未授权',
        description: '未授权，人证失败.',
      })
      router.push('/user/login')
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
    if (error.response.status === 500) {
      notification.error({
        message: '服务器内部错误',
        description: '',
      })
      return false
    }
  }
  return Promise.reject(error)
}

// request interceptor
request2.interceptors.request.use((config) => {
  const token = storage.get(ACCESS_TOKEN)
  if (token) {
    config.headers[ACCESS_TOKEN] = token
  }
  return config
}, errorHandler)

// response interceptor
request2.interceptors.response.use((response) => {
  if (response.data.code && response.data.code !== 1) {
    notification.error({
      message: response.data.msg,
      description: '',
    })
  }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request2)
  },
}

export default request2

export { installer as VueAxios, request2 as axios }
